const REFRESH_BUFFER_PER_ENV = {
  local: 40000,
  staging: 1800000,
  beta: 5400000,
  production: 5400000
};

export const REFRESH_BUFFER = REFRESH_BUFFER_PER_ENV[import.meta.env.VITE_MODE] || 40000; // 40000
